import { GridCellProps } from "@progress/kendo-react-grid";
import React, { FC } from "react";
import { ICON_NAMES } from "utils/constant";

export const CheckMarkCell: FC<
	GridCellProps & {
		checkField?: string;
		checkValue?: any;
		checked?: boolean;
	}
> = ({ ...props }) => {
	const dataItem = props.dataItem;
	let checked = dataItem[props.checkField as any] === props.checkValue;

	if (props.checked !== undefined) {
		checked = props.checked;
	}

	return (
		<td style={{ ...props.style }} className={props.className}>
			<img
				src={`/icon/${checked ? ICON_NAMES.CheckGreen : ICON_NAMES.Close}.svg`}
				alt={"check box"}
				style={{
					height: "16px",
					width: "16px",
					margin: "auto",
				}}
			/>
		</td>
	);
};

export const CheckBoxCell: FC<
	GridCellProps & {
		checkField?: string;
		checkValue?: any;
		checked?: boolean;
		onCheck?: (checked: boolean, dataItem: any) => void;
		disabled?: boolean;
		readonly?: boolean;
	}
> = ({ onCheck, disabled, readonly = true, ...props }) => {
	const dataItem = props.dataItem;
	let checked = dataItem[props.checkField as any] === props.checkValue;
	if (props.checked !== undefined) {
		checked = props.checked;
	}
	return (
		<td
			style={{ ...props.style, textAlign: "center" }}
			className={props.className}
		>
			<input
				type="checkbox"
				checked={!!checked}
				disabled={disabled}
				readOnly={readonly}
				onChange={(e) => onCheck && onCheck(e.target.checked, dataItem)}
				style={{
					width: 16,
					height: 16,
					cursor: disabled
						? "not-allowed"
						: readonly
						? "not-allowed"
						: "pointer",
				}}
			/>
		</td>
	);
};
